export default {
  methods: {
    /** Capitalizar palabras*/
    capitalize(string) {
      var words = string.split(' ');
      for (var i = 0; i < words.length; i++) {
        var word = words[i];
        words[i] = word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
      }
      return words.join(' ');
    },
    //Array a string eligiendo el separador
    implode(arr, separator = ' ') {
      return arr.join(separator);
    },
    arrayPluck(arr, propertyName) {
      return arr.map((item) => item[propertyName]);
    },
    arraySum(arr) {
      return arr.reduce((accum, current) => accum + Number(current), 0);
    },
    /**
     *
     * @param {*} number
     * @param {*} trunc
     * @returns string
     */
    number_format(number = 0, trunc = true) {
      let result = trunc ? Math.trunc(number) : Number(number).toFixed(2);
      return result.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    //Calculates the percentage of value 2 with respect to value 1
    calculatePercent(value1, value2) {
      if (value1 == 0 || value2 == 0) return 0;
      return (value2 / value1) * 100;
    },
    textTruncate(text = '', size = 30, elipsis = '...') {
      return text.length > size ? `${text.slice(0, size)}${elipsis}` : text;
    },
    /**
     * Extracts the last N words from a string.
     *
     * @param {string} value - The input string.
     * @param {number} count - Number of words to extract from the end (default: 2).
     * @returns {string} A string containing the last N words, or an empty string if the input is not a valid string.
     */
    extractLastWords(value, count = 2) {
      return typeof value === 'string'
        ? value.trim().split(/\s+/).slice(-count).join(' ')
        : '';
    },
  },
};
